export default __webpack_public_path__ + "static/media/Meta_16_9.bc72d443.png";